module.exports = __webpack_public_path__ + "heart.svg?7b42464bdd7d3750112064feb8f9e254";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reactions/heart.svg
// module id = 93
// module chunks = 0